var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from "@angular/core";
import { BaseReportItemComponent } from "app/reports/models/base-report-item-component";
var ScaleResultsSummaryComponent = /** @class */ (function (_super) {
    __extends(ScaleResultsSummaryComponent, _super);
    function ScaleResultsSummaryComponent() {
        var _this = _super.call(this) || this;
        _this.charts = [];
        _this._resultByUid = new Map();
        _this._sections = [];
        return _this;
    }
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "sections", {
        get: function () {
            if (this._sections && this._sections.length) {
                return this._sections;
            }
            return [];
        },
        enumerable: true,
        configurable: true
    });
    ScaleResultsSummaryComponent.prototype.ngOnInit = function () {
    };
    ScaleResultsSummaryComponent.prototype.ngAfterViewInit = function () {
        _super.prototype.ngAfterViewInit.call(this);
    };
    ScaleResultsSummaryComponent.prototype.getPrintClasses = function (section) {
        var styles = {
            'd-print-none': section.printHide,
            'd-none d-print-block': section.printDisplayOnly,
            'section-page-break': !section.printHide
        };
        return styles;
    };
    ScaleResultsSummaryComponent.prototype.getChartClasses = function (item) {
        if (item.chartSize) {
            var result = "p-" + item.chartSize + "-chart";
            return [result];
        }
        else {
            return ["p-small-chart"];
        }
    };
    ScaleResultsSummaryComponent.prototype.getAssessmentResult = function (uid) {
        if (this._resultByUid.has(uid)) {
            return this._resultByUid.get(uid);
        }
        return null;
    };
    ScaleResultsSummaryComponent.prototype.getScaleResultItems = function (scaleResults) {
        var _this = this;
        if (!(scaleResults && scaleResults.length)) {
            return [];
        }
        return scaleResults.map(function (sr) { return _this.getScaleResult(sr.assessmentUid, sr.scaleId); });
    };
    ScaleResultsSummaryComponent.prototype.getScaleResult = function (uid, scaleId) {
        if (this._resultByUid.has(uid)) {
            return this._resultByUid.get(uid).getScaleResultByScaleId(scaleId);
        }
        return null;
    };
    ScaleResultsSummaryComponent.prototype.getScaleResultLabels = function (uid, scaleId) {
        var result = this.getScaleResult(uid, scaleId);
        if (result) {
            return result.scale.ranges.map(function (r) { return r.displayName; });
        }
    };
    ScaleResultsSummaryComponent.prototype.hasAssessment = function (uid) {
        return this._resultByUid.has(uid);
    };
    /**
     * data => {
     * "charts" => [{
     *   "assessment: "dass-21", "scale": "88...."
     *  }]
     * }
     * @param data
     * @param results
     * @param variables
     */
    ScaleResultsSummaryComponent.prototype.setReportData = function (data, results, variables) {
        var _this = this;
        if (!data || !results) {
            return;
        }
        this._title = data.title;
        this._description = data.description;
        // if there are multiples... this uses the last instance they took...
        results.forEach(function (rs) {
            _this._resultByUid.set(rs.assessment.uid, rs);
        });
        if (data.sections) {
            this._sections = data.sections;
        }
        else {
            this._sections = [];
        }
    };
    ScaleResultsSummaryComponent.prototype.shouldPrintBreak = function (index) {
        // since index is 0 based the the user scales per page is 1 based we convert.
        return ((index + 1) == this._scales_per_page);
    };
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "ScalesPerPage", {
        get: function () {
            return this._scales_per_page;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "ScaleResults", {
        get: function () {
            return this._scaleResults;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "AssessmentResult", {
        get: function () {
            return this._assessmentResult;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "title", {
        get: function () {
            return this._title;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScaleResultsSummaryComponent.prototype, "description", {
        get: function () {
            return this._description;
        },
        enumerable: true,
        configurable: true
    });
    return ScaleResultsSummaryComponent;
}(BaseReportItemComponent));
export { ScaleResultsSummaryComponent };



// WEBPACK FOOTER //
// ./src/app/reports/report-items/scale-results-summary/scale-results-summary.component.ts.pre-build-optimizer.js